import { render, staticRenderFns } from "./taskConfigView.vue?vue&type=template&id=26846582&"
import script from "./taskConfigView.vue?vue&type=script&lang=js&"
export * from "./taskConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports